module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/headquarters/hq-grid-5-large-76c646f52024d6bd46adfce25aa3fa2f.jpg";